import { openBlock as t, createElementBlock as e, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ o("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M7.003 14.667H4.397c-1.03 0-1.85-.502-2.586-1.203-1.506-1.434.967-2.581 1.91-3.143a7.11 7.11 0 0 1 5.615-.702"
}, null, -1), c = /* @__PURE__ */ o("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M11 4.333a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
}, null, -1), s = /* @__PURE__ */ o("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M12.294 9.232c.223-.242.335-.363.454-.434a.93.93 0 0 1 .931-.014c.12.067.236.185.466.42.23.236.346.354.412.477a.99.99 0 0 1-.014.951c-.07.121-.188.236-.425.464l-2.82 2.717c-.45.433-.675.65-.956.759-.28.11-.59.102-1.207.085l-.084-.002c-.187-.005-.281-.007-.336-.07-.055-.061-.047-.157-.032-.348l.008-.104c.042-.54.063-.809.168-1.05.105-.243.287-.44.65-.833z"
}, null, -1), l = [
  n,
  c,
  s
];
function d(i, a) {
  return t(), e("svg", r, [...l]);
}
const u = { render: d };
export {
  u as default,
  d as render
};
